var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13728_2915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 6.1875C14.8125 9.35325 12.6128 11.1742 10.9643 12.9375C9.97725 13.9935 9.1875 17.4375 9.1875 17.4375C9.1875 17.4375 8.4 13.9958 7.41525 12.9427C5.76525 11.1803 3.5625 9.35625 3.5625 6.1875C3.5625 4.69566 4.15513 3.26492 5.21002 2.21002C6.26492 1.15513 7.69566 0.5625 9.1875 0.5625C10.6793 0.5625 12.1101 1.15513 13.165 2.21002C14.2199 3.26492 14.8125 4.69566 14.8125 6.1875Z",
    stroke: "#595D62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 6.1875C6.9375 6.78424 7.17455 7.35653 7.59651 7.77849C8.01847 8.20045 8.59076 8.4375 9.1875 8.4375C9.78424 8.4375 10.3565 8.20045 10.7785 7.77849C11.2004 7.35653 11.4375 6.78424 11.4375 6.1875C11.4375 5.59076 11.2004 5.01847 10.7785 4.59651C10.3565 4.17455 9.78424 3.9375 9.1875 3.9375C8.59076 3.9375 8.01847 4.17455 7.59651 4.59651C7.17455 5.01847 6.9375 5.59076 6.9375 6.1875Z",
    stroke: "#595D62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13728_2915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.388394006ca4ac15c6f529b42cd69a86.svg";
export { ForwardRef as ReactComponent };